var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contactInfo)?_c('ym-iframe-page',{staticClass:"page page-may-course-2020",attrs:{"page-url":_vm.render.pageUrl,"contact-info":_vm.contactInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }